import React from 'react';
import Immutable from 'immutable';
import {
	styled,
	Module,
	Button,
	Form,
	LookupInput,
	FormItem,
	FlexBox,
	FlexBoxBlock,
	RuntimeUtils,
	NumberUtils,
	ParentBoundComponent,
} from 'ps-gui';

import {
	CellMainText,
	CellMainTextAltToken,
	CellSubText,
	SummaryHeaderMainText,
	SummaryHeaderRowCount,
	SummaryHeaderSubText
} from './portalresultsetmodule';
import {
	ModuleBodySection,
	ModuleHeaderSection,
	ModuleHeader,
	ModuleHeaderBlock
} from '../blocks/modulesections';

import {
	getColumnText,
	getColumnTextMap,
	getFormItemLabel,
	getPhrase
} from '../data/phrases';
import AffirmationDistributionResultModel, {
	getSearchOutputColumns
} from './affirmationdistributionresultmodel';
import { withGlobalContext } from '../data/globalcontext';
import { ReactComponent as ModuleLogo } from '../svg/usagereport.svg';
import Message from '../blocks/message';
import {
	exportToCsv,
	getGlobalContextChangeChecker
} from './utils';

const Wrapper = styled.div`
`;

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);

class AffirmationDistributionResultModule extends ParentBoundComponent {

	constructor() {
		super();
		this.setRoleId = this.setRoleId.bind(this);
		this.setDistributionPeriodId = this.setDistributionPeriodId.bind(this);

		this.exportToCsv = this.exportToCsv.bind(this);
		this.onTabSelected = this.onTabSelected.bind(this);
		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
	}

	onTabSelected(tabId) {
		this.setModel(this.getModel().setSelectedTabId(tabId));
	}

	async setRoleId(roleId) {
		let model = this.getModel().setRoleId(roleId);
		this.setModel(await model.refreshSearch());
	}

	async setDistributionPeriodId(dpId) {
		let model = this.getModel().setDistributionPeriodId(dpId);
		this.setModel(await model.refreshSearch());
	}

	getModel() {
		return new AffirmationDistributionResultModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async componentDidMount() {
		await this.checkGlobalContextChange();
		const model = this.getModel();
		this.setModel(
			model
				.setSearchCustomResultProps(getCustomResultProps(model))
				//.setAggregateCustomResultProps(getCustomResultProps(model))
		);
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	renderNoData() {
		return (
			<Message>
				{getPhrase('usageReportNoDataMessage')}
			</Message>
		);
	}

	exportToCsv() {
		exportToCsv(this.getModel().getSearch(), {
			outputColumns: getSearchOutputColumns(true),
			columnTextMap: getColumnTextMap([
				'film_id',
				'title',
				'original_title',
				'production_year',
				'share_pct',
				'gross_amount',
				'cinema_attendance',
				'broadcast_effective_runtime',
				'total_sale_income',
			])
		});
	}

	render() {
		const model = this.getModel();
		const data = this.getData();
		const roleId = data.get('roleId');
		const roleLookup = data.get('roleLookup');
		const dpLookup = data.get('distributionPeriodLookup.' + roleId);
		const selectedTabId = 'search'; //data.get('selectedTabId') || 'search';
		const languageTimestamp = model.getLanguageTimestamp();
		if (!roleLookup) {
			return null;
		}
		if (roleLookup.isEmpty()) {
			return this.renderNoData();
		}
		return (
			<Wrapper>
				<ModuleHeaderSection>
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('UsageReport')}</ModuleHeader>
						<Form virtual horizontal>
							<FormItem label={getColumnText('role')} fixedWidth="470px" marginRight="30px">
								<LookupInput
									getText={roleLookup.getText}
									getRows={roleLookup.getRows}
									combo
									mandatory
									value={roleId}
									onChange={this.setRoleId}
									textRefreshTimestamp={languageTimestamp}
								/>
							</FormItem>
							{
								dpLookup &&
								<FormItem label={getColumnText('distribution_period')} fixedWidth="170px">
									<LookupInput
										getText={dpLookup.getText}
										getRows={dpLookup.getRows}
										combo
										mandatory
										value={data.get('distributionPeriodId')}
										onChange={this.setDistributionPeriodId}
										textRefreshTimestamp={languageTimestamp}
									/>
								</FormItem>

							}
						</Form>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				<ModuleBodySection>
					<RowCountEtc>
						<RowCount>
							<span className="label">{getPhrase('rowCount')}:</span>
							<span className="value">{data.getIn([
								selectedTabId,
								'data',
								'result',
								'data',
								'pager',
								'totalCount'
							])}</span>
						</RowCount>
						<Button
							type="medium"
							text={getPhrase('exportSelectionToCSV')}
							onAction={this.exportToCsv}
						/>
					</RowCountEtc>
					<Module
						key={selectedTabId}
						appState={data.get(selectedTabId)}
						onDataChange={newData => {
							this.setData(data.setIn([selectedTabId, 'data'], newData));
						}}
						customResultProps={data.get(selectedTabId + 'CustomResultProps')}
					//leftToolBar={this.renderCandidateListToolbar}
					//onResultIconMouseDown={this.onCandidateIconMouseDown}
					/>
				</ModuleBodySection>
			</Wrapper>
		);

	}
}

/*
					<TabPane
						selectedTabId={selectedTabId}
						tabs={tabs}
						onTabSelected={this.onTabSelected}
					>
						<Block24 />
					</TabPane>

*/

const Block24 = styled.div`
	height: 24px;
`;

const tabs = Immutable.fromJS([{
	id: 'search',
	text: () => getPhrase('inDetail')
}, {
	id: 'aggregate',
	text: () => getPhrase('aggregatedItems')
}]);

/* todo: hodit tyhle komponenty do jednoho mista */
const RowCountEtc = styled.div`
	margin-bottom: 24px;
`;

const RowCount = styled.div`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	font-size: 20px;
	margin-right: 40px;
	.label {
		font-weight: 400;
		margin-right: 5px;
	}
	.value {
		font-weight: 900;
	}
`;

const FlexCell = styled.div`
	display: flex;
	align-items: center;
`;

const FlexCellContent = styled.div`
	flex-grow: ${props => props.flexGrow};
	flex-shrink: ${props => props.flexShrink};
`;

const RecordingIdBlock = styled.span`
	margin-right: 8px;
	min-width: 70px;
	display: inline-block;
`;

const IsrcBlock = styled.span`
`;

const SHOW_CATEGORY_DETAIL = false;

const cellRendererMap = Object.freeze({
	'title': (cell, row, colIndex) => {
		const filmId = row.get('film_id');
		const productionYear = row.get('production_year');
		const originalTitle = row.get('original_title');
		return (
			<>
				<CellMainText>
					<CellMainTextAltToken minWidth="40px" textAlign="center" title={getColumnText('film_id')}>{filmId}</CellMainTextAltToken>
					<span className="mainToken">{cell}</span>
					{
						productionYear && (
							<CellMainTextAltToken title={getColumnText('production_year')}>({productionYear})</CellMainTextAltToken>
						)
					}
				</CellMainText>
				{
					originalTitle && (
						<CellSubText title={getColumnText('original_title')}>{originalTitle}</CellSubText>
					)
				}
			</>
		);
	},
	gross_amount: (cell, row, colIndex) => {
		if (!cell) {
			return null;
		}
		return (
			<CellMainText>{cell}<span className='unit'>{getPhrase('czk')}</span></CellMainText>
		);
	},
	sale_reward: (cell, row, colIndex) => {
		if (!cell) {
			return null;
		}
		const totalSaleIncome = row.get('total_sale_income');
		return (
			<>
				<CellMainText>{cell}<span className='unit'>{getPhrase('czk')}</span></CellMainText>
				{
					totalSaleIncome && SHOW_CATEGORY_DETAIL && (
						<CellSubText>
							<span className="label">{getFormItemLabel('totalSaleIncome')}:</span>
							<span className='value'>{formatAmount(totalSaleIncome)}</span>
							<span className='unit'>{getPhrase('czk')}</span>
						</CellSubText>
					)
				}
			</>
		);
	},
	broadcast_reward: (cell, row, colIndex) => {
		if (!cell) {
			return null;
		}
		const runtime = row.get('broadcast_effective_runtime');
		return (
			<>
				<CellMainText>{cell}<span className='unit'>{getPhrase('czk')}</span></CellMainText>
				{
					runtime && SHOW_CATEGORY_DETAIL && (
						<CellSubText>
							<span className="label">{getFormItemLabel('broadcast_effective_runtime')}:</span>
							<span className='value'>{formatNumber(runtime)}</span>
							<span className='unit'>min</span>
						</CellSubText>
					)
				}
			</>
		);
	},
	cinema_attendance_reward: (cell, row, colIndex) => {
		if (!cell) {
			return null;
		}
		const cinemaAttendance = row.get('cinema_attendance');
		return (
			<>
				<CellMainText>{cell}<span className='unit'>{getPhrase('czk')}</span></CellMainText>
				{
					cinemaAttendance && SHOW_CATEGORY_DETAIL && (
						<CellSubText>
							<span className="label">{getFormItemLabel('cinemaAttendance')}:</span>
							<span className='value'>{formatNumber(cinemaAttendance)}</span>
						</CellSubText>
					)
				}
			</>
		);
	},
	share_pct: (cell, row, colIndex) => {
		if (!cell) {
			return null;
		}
		return (
			<CellMainText className="secondary">{cell}<span className='unit'>%</span></CellMainText>
		);
	},
});

const RightHolderName = styled.div`
	position: absolute;
	top: 16px;
	left: 0px;
	width: 100%;
	text-align: left;
	font-size: 12px;
	color: #575757;
	font-weight: 500;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

function mapStationTexts(stations) {
	let res = {};
	stations.forEach(parent => {
		res[parent.get('parentId')] = parent.get('text');
		const children = parent.get('children');
		if (children) {
			children.forEach(child => {
				res[child.get('childId')] = child.get('text');
			});
		}
	});
	return res;
}

const defaultColumnWidths = {
	gross_amount: '140px',
	sale_reward: '190px',
	cinema_attendance_reward: '160px',
	broadcast_reward: '190px',
	share_pct: '140px',
};

function getCustomResultProps(model) {
	const data = model.getData();
	const stations = data.get('stations') || EMPTY_LIST;
	const stationTextMap = mapStationTexts(stations);

	return {
		cellRendererMap,
		renderSummaryHeader,
		defaultColumnWidths,
		columnFilters: {
			'cinema_attendance_reward': {
				type: 'number',
				inputSize: 8,
			},
			'sale_reward': {
				type: 'number',
				inputSize: 8,
			},
			'broadcast_reward': {
				type: 'number',
				inputSize: 8,
			},
			'cinema_attendance': {
				type: 'number',
				inputSize: 8,
			},
			'broadcast_effective_runtime': {
				type: 'number',
				inputSize: 8,
			},
			'gross_amount': {
				type: 'number',
				inputSize: 8,
			},
			'total_sale_income': {
				type: 'number',
				inputSize: 8,
			},
			'share_pct': {
				type: 'number',
				inputSize: 8,
			},
			'title': {
				type: 'text'
			},
		},
		columnAlign: {
			cinema_attendance_reward: 'right',
			broadcast_reward: 'right',
			sale_reward: 'right',
			gross_amount: 'right',
			total_sale_income: 'right',
			cinema_attendance: 'right',
			broadcast_effective_runtime: 'right',
			share_pct: 'right',
		}
	};
}

const formatNumber = NumberUtils.formatNumber;
const formatAmount = NumberUtils.getFixedDecimalFormatNumber(2);

function renderSummaryHeader(data) {
	const columns = data.get('columns') || EMPTY_LIST;
	const agg = data.get('aggregates') || EMPTY_MAP;
	return (
		<tr>
			<th colSpan={columns.size - aggDefinitions.length}>
				<FlexBox>
					<FlexBoxBlock flexGrow="1">
						<SummaryHeaderRowCount>
							<span className="label">{getPhrase('rowCount')}:</span>
							<span className="value">{data.getIn(['pager', 'totalCount'])}</span>
						</SummaryHeaderRowCount>
					</FlexBoxBlock>
					<FlexBoxBlock>
					</FlexBoxBlock>
				</FlexBox>
			</th>
			{
				aggDefinitions.map((ad, index) => {
					const name = ad.name;
					const value = ad.format(agg.get(name));
					return (
						<th key={index}>
							{
								value &&
								<>
									<SummaryHeaderMainText>{value}</SummaryHeaderMainText>
									<SummaryHeaderSubText>{getPhrase('usageReport.' + name + '.subText')}</SummaryHeaderSubText>
								</>

							}
						</th>
					);
				})
			}
		</tr>
	);
}

const aggDefinitions = [
	{ name: 'time_used_sum', format: RuntimeUtils.formatRuntime },
	{ name: 'spins_sum', format: formatNumber },
	{ name: 'ip_gross_amount_sum', format: formatAmount },
	{ name: 'np_gross_amount_sum', format: formatAmount },
];

export default withGlobalContext(AffirmationDistributionResultModule);
